import React, { useEffect, useRef, useState } from 'react';
import './activity-filters-v2.styles.scss';
import flatpickr from 'flatpickr';
import events from '@/utils/activityList.json'
import { useLocation } from 'react-router-dom';
import { properCase } from '@/utils/properCase';

const ActivityFiltersV2 = ({
  gameData,
  gameManagers,
  playerList,
  gameElements,
  queryFilter,
  setQueryFilter,
  resetFilter,
  setResetFilter
}) => {

  const [filterData, setFilterData] = useState([]);
  const [activityTypes, setActivityTypes] = useState([]);
  const filterDataRef = useRef([]);
  const date1Ref = useRef();
  const date2Ref = useRef();
  const location = useLocation();

  useEffect(() => {
    const openDateElement = document.getElementById('startDate');
    if (!openDateElement) return;
    if (!date1Ref.current) {
      const flat1 = flatpickr(openDateElement,
        {
          // altInput: true,
          // altFormat: "F j, Y",
          enableTime: false,
          dateFormat: "F j, Y",
          onChange: (dates) => {
            const date = new Date(dates[0]).getTime();
            saveFilterData('startDate', date);
          }
        }
      );
      date1Ref.current = flat1;
      // console.log('set fp')
    }
    const closeDateElement = document.getElementById('endDate');
    if (!date2Ref.current) {
      const flat2 = flatpickr(closeDateElement,
        {
          // altInput: true,
          // altFormat: "F j, Y",
          enableTime: false,
          dateFormat: "F j, Y",
          onChange: (dates) => {
            const date = new Date(dates[0]).getTime() + 86400000 - 1;
            saveFilterData('endDate', date)
          }
        }
      );
      date2Ref.current = flat2;
      // console.log('set date2')
    }
  }, [])

  useEffect(() => {
    if (!events) return;
    if (location.pathname === `/manage/${gameData.path}/activity`) {
      setActivityTypes(events.managerActivityList.concat(events.playerActivityList));
    } else if (
      location.pathname === `/manage/${gameData.path}/actionitems` ||
      location.pathname === `/preview/manager/${gameData.path}/actionitems`
    ) {
      setActivityTypes(events.actionItemList);
    } else if (
      location.pathname === `/play/${gameData.path}/gameactivity` ||
      location.pathname.includes('/preview/player/')
    ) {
      setActivityTypes(events.playerActivityList);
    }
  }, [events])

  useEffect(() => {
    if (!queryFilter) return;
    filterDataRef.current = [...queryFilter];
    setFilterData(filterDataRef.current);
  }, [queryFilter])

  useEffect(() => {
    if (resetFilter) {
      clearFilter();
    } 
  }, [resetFilter])

  function saveFilterData(key, value) {
    let tempData = [...filterDataRef.current];
    if (!value) {
      tempData = tempData.filter(e => e.key !== key);
    } else {
      if (tempData.length > 0) {
        let keys = tempData.map(e => e.key);
        console.log(keys);
        const index = keys.indexOf(key);
        if (index > -1) {
          tempData[index] = { key, value };
        } else {
          tempData.push({ key, value });
        }
      } else {
        tempData.push({ key, value });
      }
    }
    filterDataRef.current = [...tempData];
    setFilterData(filterDataRef.current);
    setQueryFilter(filterDataRef.current);
  }

  function clearFilter() {
    filterDataRef.current = [...filterDataRef.current
    .filter(f => f.key === 'type' || f.key === 'status')];
    console.log(filterDataRef.current);
    setFilterData(filterDataRef.current);
    setQueryFilter(filterDataRef.current);
    date1Ref.current.clear();
    date2Ref.current.clear();
    setResetFilter(false);
  }

  return (
    <div className='activity-filters-v2'>
      {
        (gameManagers?.length > 0) &&
        <div className='field small'>
          <select
            value={
              filterData.filter(f => f.key === 'appId').length > 0
              ? filterData.find(f => f.key === 'appId')?.value
              : ''
            }
            onChange={(e) => saveFilterData('appId', e.target.value)}
          >
            <option value=''>Choose a Manager...</option>
            {
              (gameManagers) &&
              gameManagers.map(m => {
                return (
                  <option key={m.appId} value={m.appId}>
                    {m.name}
                  </option>
                )
              })
            }
          </select>
        </div>
      }
      {
        (
          !location.pathname.includes('/play/') &&
          !location.pathname.includes('/preview/player/') &&
          filterData
        ) &&
        <div className='field small'>
          <select
            value={
              filterData.filter(f => f.key === 'playerId').length > 0 ?
              filterData.find(f => f.key === 'playerId')?.value
              : ''
            }
            onChange={(e) => saveFilterData('playerId', e.target.value)}
          >
            <option value=''>Choose a Player...</option>
            {
              (playerList) &&
              Object.values(playerList)
              .filter(p => !p.team)
              .sort((a, b) => a.lName < b.lName ? -1 : 1)
              .map(p => {
                return (
                  <option key={p.playerId} value={p.playerId}>
                    {p.lName ? `${p.lName}, ` : ''}
                    {p.fName}
                  </option>
                )
              })
            }
          </select>
        </div>
      }
      <div className='field small'>
        <select
          value={
            filterData.filter(f => f.key === 'event').length > 0
              ? filterData.find(f => f.key === 'event')?.value
              : ''
          }
          onChange={(e) => saveFilterData('event', e.target.value)}
        >
          <option value=''>Choose an Activity...</option>
          {
            (activityTypes) &&
            activityTypes
              .sort()
              .map((t, i) => (
                <option key={t + i} value={t}>{t}</option>
              ))
          }
        </select>
      </div>
      <div className='field small'>
        <select
          value={
            filterData.filter(f => f.key === 'elementId').length > 0
              ? filterData.find(f => f.key === 'elementId')?.value
              : ''
          }
          onChange={(e) => saveFilterData('elementId', e.target.value)}
        >
          <option value=''>Choose a Game Element...</option>
          {
            (gameElements) &&
            Object.values(gameElements)
            // sort by name, but ignore the initial "The", "A", or "An"
            .sort((a, b) => {
              const labelA = `${properCase(a.type)}${a.type === 'item' ? ` (${properCase(a.opt_itemType)})` : ''} | ${a.name}`;
              const labelB = `${properCase(b.type)}${b.type === 'item' ? ` (${properCase(b.opt_itemType)})` : ''} | ${b.name}`;
              return labelA < labelB ? -1 : 1;
            })
            .map(i => {
              const label = `${properCase(i.type)}${i.type === 'item' ? ` (${properCase(i.opt_itemType)})` : ''} | ${i.name}`;
              return (
                <option key={i.id} value={i.id}>{label}</option>
              )
            })
          }
        </select>
      </div>
      <div className='field small'>
        <input
          className="flatpickr flatpickr-input"
          type="text"
          id="startDate"
          placeholder='Choose a Start Date...'
        />
      </div>
      <div className='field small'>
        <input
          className="flatpickr flatpickr-input"
          type="text"
          id="endDate"
          placeholder='Choose an End Date...'
        />
      </div>
      <div className="g-space-0-5"></div>
      {/* <div className='buttons'>
        <button
          className='g-button med-btn'
          onClick={() => clearFilter({})}
        >
          Clear
        </button>
      </div> */}
    </div>
  )
}

export default ActivityFiltersV2